import React from 'react';
import AutoNumberSettingSection from './AutoNumberSettingSection';
import MfaSettingSection from './MfaSettingSection';
import CustomFieldsSettingsSection from './CustomFieldsSettingsSection';
import { useSelector } from 'react-redux';
import OrgNotificationSection from './OrgNotificationSection';
import NotificationToBuyerOnDocumentApprovalSettingSection from './NotificationToBuyerOnDocumentApprovalSettingSection';

const OrgSettingsSection = () => {
  const subscription = useSelector((state) => state.subscription.subscription);
  const isCustomFieldsEnabled = subscription?.features?.enable_custom_fields;

  return (
    <>
      <AutoNumberSettingSection />
      <NotificationToBuyerOnDocumentApprovalSettingSection />
      <MfaSettingSection />
      {isCustomFieldsEnabled && <CustomFieldsSettingsSection />}
    </>
  );
};

export default OrgSettingsSection;
